<a href="{{ fileUpload.url }}">{{ fileUpload.name }}</a>
<button (click)="deleteFileUpload(fileUpload)" class="btn btn-danger btn-sm" style="float: right">
    Usuń
  </button>